import { Injector, Injectable } from '@angular/core';
import { LocalizationService } from "../../../../../../node_modules/abp-ng2-module/dist/src/localization/localization.service";
import { AppConsts } from "../../../../../shared/AppConsts";

@Injectable({
	providedIn: 'root'
})


export class CustomLocalizationService{
	
	
	private localizationSourceName = AppConsts.localization.defaultLocalizationSourceName;

	private localization: LocalizationService;


	constructor(injector: Injector) {
		this.localization = injector.get(LocalizationService);
		
	}


	l(key: string) {
		return this.localization.localize(key, this.localizationSourceName);
	}

}
